<template>
    <div>
        <b-container fluid class="m-0 p-0">
            <b-row
                class="legend-row d-flex"
                v-if="layer.geometryType.includes('P')"
            >
                <b-col class="flex-grow-0 pr-0" v-if="iconDefault">
                    <img
                        :src="iconDefault"
                        class="legendpointimage"
                        :alt="$t('legendImageAlt', [layer.title])"
                    />
                </b-col>
                <b-col v-if="!iconDefault" class="flex-grow-0 pr-0">
                    <div
                        class="legendpoint"
                        :style="$_getStylePointObject(layer, true)"
                    ></div>
                </b-col>
                <b-col class="legend-col">
                    {{ $t('geomPoint') }}
                </b-col>
            </b-row>
            <b-row
                class="legend-row d-flex"
                v-if="layer.geometryType.includes('L')"
            >
                <b-col class="flex-grow-0 pr-0">
                    <div :style="$_getStyleLineObject(layer)"></div>
                </b-col>
                <b-col class="legend-col">
                    {{ $t('geomLine') }}
                </b-col>
            </b-row>
            <b-row
                class="legend-row d-flex"
                v-if="layer.geometryType.includes('V')"
            >
                <b-col class="flex-grow-0 pr-0">
                    <div :style="$_getStylePointObject(layer, false)"></div>
                </b-col>
                <b-col class="legend-col flex-grow-1">
                    {{ $t('geomPolygon') }}
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    export default {
        name: 'legend-style-css',
        props: {
            layer: { type: Object, required: true },
            hideFill: { type: Boolean, required: false, default: false }
        },
        computed: {
            iconDefault() {
                return this.layer.styles[0].iconDefaultReplacedParams || this.layer.styles[0].iconDefault;
            }
        },
        methods: {
            /**
             * Get the line style
             */
            $_getStyleLineObject(layer) {
                return {
                    width: '15px',
                    height: '2px',
                    border: `${layer.styles[0].strokeWidthDefault}px solid ${layer.styles[0].fillColorDefault}`,
                    'background-color': layer.styles[0].fillColorDefault,
                    'margin-right': '10px'
                };
            },

            /**
             * Get the point style
             */
            $_getStylePointObject(layer, isPoint) {
                const layerStyle = layer.styles[0];
                const color = this.hideFill
                    ? 'transparent'
                    : layerStyle.fillColorDefault;
                return {
                    ...(layerStyle.imageSvg &&
                        !isPoint && {
                            'background-image': `url('${layerStyle.imageSvg}')`,
                            'background-repeat': 'no-repeat',
                            'background-position': 'center'
                        }),
                    'background-color': color,
                    width: '15px',
                    height: '15px',
                    border: `${layerStyle.strokeWidthDefault}px solid ${layerStyle.strokeColorDefault}`,
                    'margin-right': '10px'
                };
            }
        }
    };
</script>

<style scoped>
.legend-row {
    padding: 1px 0px;
    align-items: center;
    margin-right: 0;
}

.legend-col {
    align-self: center;
    padding-left: 0px;
    padding-right: 0px;
    word-break: break-word;
}

.legendpoint {
    border-radius: 50%;
    display: block;
}

.legendpointimage {
    width: 15px;
    margin-right: 10px;
}
</style>
